export class FormControlBase<T>{
    public value: T;
    public key: string = '';
    public label: string = '';
    public required: boolean = false;
    public validNoNumber: boolean = false;
    public validEmail: boolean = false;
    public validNumberOnly: boolean = false;
    public disabled: boolean = false;
    public order: number = 1;
    public controlType: string = '';
    public warning: string = '';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/form-control-base.ts